module.exports = __webpack_public_path__ + "media/images/salespartner/salespartner02-84b3864042580c3fbf4806972993d16b.svg";